// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes wobble {

    0%,
    100% {
        transform: rotate(-2deg);
    }

    50% {
        transform: rotate(2deg);
    }
}

.image-tile.wobble {
    animation: wobble 0.5s ease-in-out infinite;
}

.image-tile {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(25% - 4px);
    max-width: calc(25% - 4px);
    margin: 2px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    padding-top: calc(25% - 4px);
}

.image-tile img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.image-tile.is-dragging {
    z-index: 9998; /* Higher z-index when dragging */
}

.image-tile-checkbox-container {
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 10000;
}

.image-tile-checkbox-container input {
    display: none;
}

.image-tile-checkbox-container .checkbox {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 3px solid var(--color-primaryLight);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    background-color: transparent;
    transition: background-color 0.2s;
}

.image-tile-checkbox-container .checkbox::before {
    content: '✓';
    font-size: 20px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0);
    transition: color 0.2s;
}

.image-tile-checkbox-container.selected .checkbox {
    background-color: var(--color-primaryLight);
}

.image-tile-checkbox-container.selected .checkbox::before {
    color: var(--color-grey000);
}

.image-tile-drag-handle {
    position: absolute;
    bottom: 2px;
    right: 2px;
    cursor: grab;
    color: var(--color-primaryLight);
    z-index: 9999;
}

.image-tile-drag-handle .icon-drag-handle {
    font-size: 20px;
}

@media (min-width: 1200px) {
    .image-tile {
        max-width: 200px;
        padding-top: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ImageTile.css"],"names":[],"mappings":"AAAA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":["@keyframes wobble {\n\n    0%,\n    100% {\n        transform: rotate(-2deg);\n    }\n\n    50% {\n        transform: rotate(2deg);\n    }\n}\n\n.image-tile.wobble {\n    animation: wobble 0.5s ease-in-out infinite;\n}\n\n.image-tile {\n    flex: 1 0 calc(25% - 4px);\n    max-width: calc(25% - 4px);\n    margin: 2px;\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n    padding-top: calc(25% - 4px);\n}\n\n.image-tile img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n}\n\n.image-tile.is-dragging {\n    z-index: 9998; /* Higher z-index when dragging */\n}\n\n.image-tile-checkbox-container {\n    position: absolute;\n    bottom: 5px;\n    right: 5px;\n    z-index: 10000;\n}\n\n.image-tile-checkbox-container input {\n    display: none;\n}\n\n.image-tile-checkbox-container .checkbox {\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    border: 3px solid var(--color-primaryLight);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    background-color: transparent;\n    transition: background-color 0.2s;\n}\n\n.image-tile-checkbox-container .checkbox::before {\n    content: '✓';\n    font-size: 20px;\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0);\n    transition: color 0.2s;\n}\n\n.image-tile-checkbox-container.selected .checkbox {\n    background-color: var(--color-primaryLight);\n}\n\n.image-tile-checkbox-container.selected .checkbox::before {\n    color: var(--color-grey000);\n}\n\n.image-tile-drag-handle {\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    cursor: grab;\n    color: var(--color-primaryLight);\n    z-index: 9999;\n}\n\n.image-tile-drag-handle .icon-drag-handle {\n    font-size: 20px;\n}\n\n@media (min-width: 1200px) {\n    .image-tile {\n        max-width: 200px;\n        padding-top: 200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
